import axios from 'axios';
import { setupAxios } from '@carvana/core-auth';
import Cookies from 'js-cookie';

const axiosBase = (config: { timeout: number } = { timeout: 10000 }) => {
  const instance = axios.create(config);

  return setupAxios(instance, { addBearerTokenToAllRequests: true });
};

export default axiosBase;
